// Free Download Price Fix
// This script overrides the price update functionality to show "FREE" for free download products

(function () {
  "use strict";

  let isFreeDownload = false;
  let observer = null;
  let updateInterval = null;
  let originalFormatMoney = null;

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  function init() {
    // Wait a bit for the page to fully load
    setTimeout(function () {
      isFreeDownload = checkIfFreeDownload();

      if (isFreeDownload) {
        // Override Shopify.formatMoney function
        overrideFormatMoney();

        // Initial update
        updateFreeDownloadPrices();

        // Set up multiple monitoring approaches
        setupEventListeners();
        setupMutationObserver();
        setupPolling();

        // Also run immediately and after a delay
        setTimeout(updateFreeDownloadPrices, 100);
        setTimeout(updateFreeDownloadPrices, 500);
        setTimeout(updateFreeDownloadPrices, 1000);
      }
    }, 500);
  }

  function overrideFormatMoney() {
    // Store the original formatMoney function
    if (window.Shopify && window.Shopify.formatMoney) {
      originalFormatMoney = window.Shopify.formatMoney;

      // Override the formatMoney function
      window.Shopify.formatMoney = function (amount, format) {
        // If amount is 0 or very close to 0, return "FREE" for free download products
        if (isFreeDownload && (amount === 0 || amount < 0.01)) {
          return "FREE";
        }

        // Otherwise, use the original function
        return originalFormatMoney.call(this, amount, format);
      };
    } else {
      // Retry after a delay
      setTimeout(overrideFormatMoney, 1000);
    }
  }

  function setupEventListeners() {
    // Listen for variant changes
    document.addEventListener(
      "shopify-variants:switch-variant",
      function (event) {
        setTimeout(updateFreeDownloadPrices, 50);
        setTimeout(updateFreeDownloadPrices, 200);
      }
    );

    // Listen for any form changes
    document.addEventListener("change", function (event) {
      if (
        event.target.matches(
          '[data-product-option], [data-variants], select, input[type="radio"]'
        )
      ) {
        setTimeout(updateFreeDownloadPrices, 100);
        setTimeout(updateFreeDownloadPrices, 300);
      }
    });

    // Listen for URL changes (variant selection via URL)
    let lastUrl = location.href;
    new MutationObserver(() => {
      const url = location.href;
      if (url !== lastUrl) {
        lastUrl = url;
        setTimeout(updateFreeDownloadPrices, 100);
        setTimeout(updateFreeDownloadPrices, 500);
      }
    }).observe(document, { subtree: true, childList: true });
  }

  function setupMutationObserver() {
    // Watch for changes to price elements
    observer = new MutationObserver(function (mutations) {
      let shouldUpdate = false;

      mutations.forEach(function (mutation) {
        if (
          mutation.type === "childList" ||
          mutation.type === "characterData"
        ) {
          // Check if any price elements were modified
          const priceElements = document.querySelectorAll(
            "[data-price] .money, [data-price-compare-at] .money, [data-unit-price-amount]"
          );
          priceElements.forEach(function (element) {
            if (
              element.textContent.includes("$0.00") ||
              element.textContent.includes("$0")
            ) {
              shouldUpdate = true;
            }
          });
        }
      });

      if (shouldUpdate) {
        updateFreeDownloadPrices();
      }
    });

    // Observe the entire document for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  function setupPolling() {
    // Poll for price changes every 2 seconds
    updateInterval = setInterval(function () {
      if (isFreeDownload) {
        const priceElements = document.querySelectorAll(
          "[data-price] .money, [data-price-compare-at] .money, [data-unit-price-amount]"
        );
        let needsUpdate = false;

        priceElements.forEach(function (element) {
          if (
            element.textContent.includes("$0.00") ||
            element.textContent.includes("$0")
          ) {
            needsUpdate = true;
          }
        });

        if (needsUpdate) {
          updateFreeDownloadPrices();
        }
      }
    }, 2000);
  }

  function updateFreeDownloadPrices() {
    if (!isFreeDownload) return;

    // Find all price elements
    const priceElements = document.querySelectorAll("[data-price] .money");
    const comparePriceElements = document.querySelectorAll(
      "[data-price-compare-at] .money"
    );
    const unitPriceElements = document.querySelectorAll(
      "[data-unit-price-amount]"
    );

    let updated = false;

    // Update main price elements
    priceElements.forEach(function (element) {
      if (
        element.textContent.includes("$0.00") ||
        element.textContent.includes("$0")
      ) {
        element.textContent = "FREE";
        updated = true;
      }
    });

    // Update compare price elements
    comparePriceElements.forEach(function (element) {
      if (
        element.textContent.includes("$0.00") ||
        element.textContent.includes("$0")
      ) {
        element.textContent = "FREE";
        updated = true;
      }
    });

    // Update unit price elements
    unitPriceElements.forEach(function (element) {
      if (
        element.textContent.includes("$0.00") ||
        element.textContent.includes("$0")
      ) {
        element.textContent = "FREE";
        updated = true;
      }
    });
  }

  function checkIfFreeDownload() {
    // Check if product has "Free Downloads" tag
    const productTags = document.querySelector("[data-product-tags]");
    if (productTags) {
      const tags = productTags.getAttribute("data-product-tags") || "";
      if (tags.includes("Free Downloads")) {
        return true;
      }
    }

    // Check if product type is "Free Download"
    const productType = document.querySelector("[data-product-type]");
    if (productType) {
      const type = productType.getAttribute("data-product-type") || "";
      if (type === "Free Download") {
        return true;
      }
    }

    // Check if explicitly marked as free download
    const isFreeDownload = document.querySelector(
      '[data-is-free-download="true"]'
    );
    if (isFreeDownload) {
      return true;
    }

    // Check if any price is $0.00 and product has free download indicators
    const priceElements = document.querySelectorAll("[data-price] .money");
    const hasZeroPrice = Array.from(priceElements).some(function (element) {
      return (
        element.textContent.includes("$0.00") ||
        element.textContent.includes("$0")
      );
    });

    if (hasZeroPrice) {
      // Look for free download indicators in the page
      const pageText = document.body.textContent.toLowerCase();
      if (
        pageText.includes("free download") ||
        pageText.includes("free downloads")
      ) {
        return true;
      }
    }

    return false;
  }

  // Cleanup function
  function cleanup() {
    if (observer) {
      observer.disconnect();
    }
    if (updateInterval) {
      clearInterval(updateInterval);
    }

    // Restore original formatMoney function
    if (originalFormatMoney && window.Shopify) {
      window.Shopify.formatMoney = originalFormatMoney;
    }
  }

  // Cleanup on page unload
  window.addEventListener("beforeunload", cleanup);
})();
